import { formatDistanceToNow } from 'date-fns';
import CitizensReportIcon from './images/citizens-report.svg';
import './Notifications.css';
import { bs } from 'date-fns/locale';
import { ClipLoader } from 'react-spinners';

function NotificationsList({ notifications, isFetching }) {
  return (
    <div className="notifications-list">
      {isFetching && (
        <div className="notifications-spinner">
          <ClipLoader
            color={'gray'}
            loading={true}
            size={45}
            data-testid="loader"
          />
        </div>
      )}

      {!isFetching &&
        notifications?.map((notification) => (
          <div key={notification.id}>
            <div
              className="notification-container"
              style={{
                backgroundColor: !notification.read ? '#F6FDFD' : '#FFF',
              }}
            >
              <div
                className="notification-icon"
                style={{
                  backgroundColor: notification.type === 0 ? '#079c6a' : '#FFF',
                }}
              >
                <img
                  height={10}
                  src={notification.type === 0 ? CitizensReportIcon : ''}
                  alt=""
                />
              </div>

              <div className="notification-body">
                <div className="notification-message">
                  {notification.message}
                </div>

                <div className="notification-title">
                  {notification.title}
                  <span className="notification-message-separator">●</span>
                  {formatDistanceToNow(notification.createdAt, {
                    addSuffix: true,
                    locale: bs,
                  })}
                </div>
              </div>
            </div>

            <div className="notifications-modal-title-border"></div>
          </div>
        ))}
    </div>
  );
}

export default NotificationsList;
